<div class="table-responsive">
  @if (articles && articles.length) {
    <table class="table text-nowrap table-striped">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">{{'QUANTITY' | translate}}</th>
          <th scope="col">{{'DESCRIPTION' | translate}}</th>
          <th scope="col">{{'FRAMENUMBER' | translate}}</th>
          <th scope="col">{{'EMPLOYEE' | translate}}</th>
          <th scope="col">{{'TYPE' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        @for (article of articles; track article; let articleIndex = $index) {
          @if (article) {
            <app-warranty-details-article
              [article]="article"
              [showControls]="showControls"
              (deleted)="deleteArticle(articleIndex)"
              (added)="added.emit(true)"
              class="d-table-row"
              >
            </app-warranty-details-article>
          }
        }
      </tbody>
    </table>
  }
</div>
